import type { CodigoDeActivacionEmitido, SesionRenovada } from '@pasos/schemas';
import { enviar } from '../lib/api.js';

/**
 * El código de activación (INGRESO-2). Una función por endpoint, sin lógica.
 *
 * Pedirlo viaja con la sesión de quien ya entró; canjearlo, sin sesión: la
 * respuesta trae el ID token ya canjeado y el servidor deja la cookie del
 * dispositivo, así la app instalada vuelve sola la próxima vez.
 */

export const pedirCodigo = () => enviar<CodigoDeActivacionEmitido>('/api/v1/auth/activacion', {});

export const canjearCodigo = (codigo: string) =>
  enviar<SesionRenovada>('/api/v1/auth/activacion/canjear', { codigo });
